import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\ModelNotification\ChangePublicStatusModelNotificationController::__invoke
* @see app/Http/Controllers/ModelNotification/ChangePublicStatusModelNotificationController.php
* @route '/api/change-public-status'
*/
const ChangePublicStatusModelNotificationController = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: ChangePublicStatusModelNotificationController.url(options),
    method: 'post',
})

ChangePublicStatusModelNotificationController.definition = {
    methods: ["post"],
    url: '/api/change-public-status',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\ModelNotification\ChangePublicStatusModelNotificationController::__invoke
* @see app/Http/Controllers/ModelNotification/ChangePublicStatusModelNotificationController.php
* @route '/api/change-public-status'
*/
ChangePublicStatusModelNotificationController.url = (options?: RouteQueryOptions) => {
    return ChangePublicStatusModelNotificationController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\ModelNotification\ChangePublicStatusModelNotificationController::__invoke
* @see app/Http/Controllers/ModelNotification/ChangePublicStatusModelNotificationController.php
* @route '/api/change-public-status'
*/
ChangePublicStatusModelNotificationController.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: ChangePublicStatusModelNotificationController.url(options),
    method: 'post',
})

export default ChangePublicStatusModelNotificationController